import IntegerBase from './integer-base';

export default class PositiveNonzeroInteger extends IntegerBase {
  minInt = 1;
}
